import React from 'react';
import "./factorTitleAndScore.scss";
import {getClassNameByScore, getClassNameContainerByScore, isNA} from "./callScoreHelpers";
import PropTypes from "prop-types";
import {Button, Tooltip} from "@mui/material";

const FactorWithScore = ({title, actual, total}) => {
    return <div className={"content"}>
        <p className={"title"}>{title}</p>
        <p className={`value ${getClassNameByScore(actual, total)}`}>
            {
                isNA(actual) ? actual.toString().toUpperCase() : `${actual}/${total}`
            }
        </p>
    </div>
}
const FactorTitleAndScore = ({title, actual, total, showGreyBackground, summary, showCallSummary, index, onFactorClick, activeFactorIndex, factorsLength}) => {

    const toggleTooltip = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onFactorClick(index);
    }
    return (showCallSummary && summary && !isNA(summary)) ? <div className={`factor ${showGreyBackground ? 'grey-background' : ""} ${showCallSummary ? getClassNameContainerByScore(actual, total) : ""}`}>
            <Tooltip open={index === activeFactorIndex} title={summary} placement={"top"} classes={{arrow: "tooltip-arrow", tooltip: "factor-summary"}} arrow>
        <Button onClick={toggleTooltip}>
            <FactorWithScore title={title} actual={actual} total={total} showGreyBackground={showGreyBackground}
                             showCallSummary={showCallSummary}/>
        </Button>
        </Tooltip></div>
        : <div className={`factor without-tooltip custom-factor-display ${showGreyBackground ? 'grey-background' : ""} ${showCallSummary ? getClassNameContainerByScore(actual, total) : ""} ${!!factorsLength && index === factorsLength - 1 && factorsLength > 3 ? 'remove-flex': ''}`}>
            <FactorWithScore title={title} actual={actual} total={total} showGreyBackground={showGreyBackground}
                           showCallSummary={showCallSummary}/>
        </div>
}

FactorTitleAndScore.prototype = {
    title: PropTypes.string,
    actual: PropTypes.number,
    total: PropTypes.number,
    showGreyBackground: PropTypes.bool,
    summary: PropTypes.string,
    showCallSummary: PropTypes.bool,
    index: PropTypes.number,
    activeFactorIndex: PropTypes.number,
    onFactorClick: PropTypes.func
}
export default FactorTitleAndScore;